import CalculateScoreButton from './CalculateScoreButton';

export default CalculateScoreButton;
